export default {
  namespaced: true,

  state: {
    currentStep: 1,
  },

  actions: {
    goToStepBrandColorSelection({ dispatch, commit }) {
      dispatch('brand-color-selection/getBrandColorTypes', null, {
        root: true,
      });

      commit('setStep', 2);
    },
    goToStepFinishOrder({ dispatch, commit }) {
      dispatch('order/fetchProducts', null, {
        root: true,
      });

      commit('setStep', 3);
    },
  },

  mutations: {
    setStep(state, step) {
      const prevStep = state.currentStep;

      state.currentStep = step;

      window.dispatchEvent(
        new CustomEvent('step-changed', {
          detail: { prevStep, step },
        })
      );
    },
    setStepRaw(state, step) {
      state.currentStep = step;
    },
  },
};
